// Base URLs for every Forge API surface, derived once from REACT_APP_API_DL_URL.

function normalizeApiDlUrl(url: string): string {
  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.protocol === 'http:' && ['localhost', '127.0.0.1'].includes(parsedUrl.hostname)) {
      if (process.env.NODE_ENV === 'development') {
        // The local app proxies API DL through the same origin. This keeps the browser on the
        // slot's frontend port and avoids direct cross-origin access to the slot API.
        return '/api-dl';
      }
      parsedUrl.hostname = '127.0.0.1';
      return parsedUrl.toString().replace(/\/$/, '');
    }
  } catch {
    return url;
  }

  return url.replace(/\/$/, '');
}

const API_DL_URL = process.env.REACT_APP_API_DL_URL
  ? normalizeApiDlUrl(process.env.REACT_APP_API_DL_URL)
  : undefined;

if (!API_DL_URL) {
  throw new Error('REACT_APP_API_DL_URL is required for Forge API requests');
}

export const FORGE_ADMIN_API_URL = `${API_DL_URL}/v1/forge/admin`;

export const FORGE_CROPS_API_URL = `${API_DL_URL}/v1/forge/crops`;

export const FORGE_DESIGNS_API_URL = `${API_DL_URL}/v1/forge/designs`;

export const FORGE_DESIGN_LOCKS_API_URL = `${API_DL_URL}/v1/forge/design-locks`;

export const CONTROL_EMBEDDING_API_URL = `${API_DL_URL}/v1/control/embedding`;

export const CONTROL_TARGETED_DATA_COLLECTION_API_URL = `${API_DL_URL}/v1/control/targeted-data-collection`;

export const FORGE_DASHBOARDS_API_URL = `${FORGE_ADMIN_API_URL}/dashboards`;

export const FORGE_STORE_DC_API_URL = `${FORGE_ADMIN_API_URL}/store-dc`;

export const FORGE_DESIGN_GROUPS_API_URL = `${FORGE_ADMIN_API_URL}/design-groups`;

export const FORGE_MASTER_DATA_COLLECTION_API_URL = `${FORGE_ADMIN_API_URL}/master-data-collection`;

export const FORGE_CLEANING_TOOL_API_URL = `${API_DL_URL}/v1/forge/labeling-tools/cleaning-tool`;

export const FORGE_PR_REVIEW_API_URL = `${FORGE_ADMIN_API_URL}/pr-review`;

export const FORGE_PR_REPLAY_API_URL = `${FORGE_ADMIN_API_URL}/pr-replay`;

export const FORGE_REMOTE_DATA_COLLECTION_API_URL = `${FORGE_ADMIN_API_URL}/remote-data-collection`;

export const FORGE_VIZSIM_DATASETS_API_URL = `${FORGE_ADMIN_API_URL}/vizsim-datasets`;

export const FORGE_CLEANING_API_URL = `${FORGE_ADMIN_API_URL}/cleaning-tasks`;

export const FORGE_FALSE_DETECTION_API_URL = `${FORGE_ADMIN_API_URL}/false-detection-tasks`;

export const REPORTED_ISSUES_API_URL = `${API_DL_URL}/v1/image/reported-issues`;
export const SCAN_ASSIGNMENTS_API_URL = `${API_DL_URL}/v1/forge/scan-assignments`;
export const SCAN_THRESHOLDS_API_URL = `${API_DL_URL}/v1/forge/scan-assignment-thresholds`;
